import { differenceInCalendarDays } from "date-fns";
import { startOfDay } from "date-fns/fp";
import { NoticeState } from "./types";

const isEaster = (today: Date): boolean => {
    const year = today.getFullYear();

    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31); // 3 = March, 4 = April
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    const easterSunday = new Date(year, month - 1, day);
    const daysDiff = differenceInCalendarDays(today, easterSunday);

    // Holy Week Monday (-6) through the Sunday after Easter (+7)
    return daysDiff >= -6 && daysDiff <= 7;
};

export const getNoticeForToday = (): NoticeState => {
    const today = startOfDay(new Date());

    if (isEaster(today)) {
        return { active: true, type: "EASTER" };
    }

    return { active: false, type: undefined };
};
